import moment from 'moment';

// Strict ISO-8601 datetime so we never touch reference numbers / plain strings.
const ISO_DATETIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
export const NUMERIC = /^-?\d+(\.\d+)?$/;

const isMoneyColumn = (name: string) => name.indexOf('$') !== -1;

/**
 * How a report table shows a cell: ISO datetimes in the viewer's zone, `$` columns with
 * thousands separators, everything else as returned. Shared by the on-screen table and
 * the Excel download so the two can never drift apart.
 */
export const formatCell = (value: any, columnName: string) => {
  if (value === null || value === undefined || value === '') {
    return value;
  }
  if (typeof value === 'string' && ISO_DATETIME.test(value)) {
    return moment(value).format('DD MMM YYYY, h:mm A');
  }
  const isNumeric = typeof value === 'number' || (typeof value === 'string' && NUMERIC.test(value));
  if (isNumeric && isMoneyColumn(columnName)) {
    return Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });
  }
  return value;
};
